import { InfoCircleOutlined } from '@ant-design/icons';
import type { RadioChangeEvent } from 'antd';
import { Form, Radio, Tooltip } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

const REQUIRED_RULE = [{ required: true, message: 'Required' }];

type ShowInInventoryFieldProps = {
  onChange: (e: RadioChangeEvent) => void;
};

export const ShowInInventoryField = ({
  onChange,
}: ShowInInventoryFieldProps) => {
  const { isViewMode } = useContext(ViewEditModeContext);

  return (
    <FormLineLayout
      isRequired
      label={
        <div>
          Show in Inventory{' '}
          <Tooltip title="Select “No” if this activity doesn’t require its own inventory. This keeps the hotel’s Extranet inventory clean and easy to manage (e.g. coffee, pancakes, estate access).">
            <InfoCircleOutlined />
          </Tooltip>
        </div>
      }
      labelOnTop
      disabled={isViewMode}
    >
      <Form.Item name="showInInventory" rules={REQUIRED_RULE}>
        <Radio.Group disabled={isViewMode} onChange={onChange}>
          <Radio value={true}>
            Yes{' '}
            <span
              className={classNames(!isViewMode ? 'radio-helper-text' : '')}
            >
              - Managed by the hotel in the Extranet Inventory
            </span>
          </Radio>
          <Radio value={false}>
            No{' '}
            <span
              className={classNames(!isViewMode ? 'radio-helper-text' : '')}
            >
              - Hidden from the hotel inventory (no stock required)
            </span>
          </Radio>
        </Radio.Group>
      </Form.Item>
    </FormLineLayout>
  );
};
